<template>
  <div class="imdiv shmim">
    <div v-on:click="zoom" class="cursable">
      <div class="square-filler" :class="{wide: artistData.wide, big: artistData.big}" v-if="artist && artist.portfolio_url">
        <ix-router-link :to="pfurl">
          <img v-if="seendone" :src="currentUrl" :alt="alt" class="smain absim" :class="{loaded: picloaded}" />
        </ix-router-link>
      </div>
    </div>
    <div class="greybar" v-show="loaded">
        <div>
          <div class="a-name" v-on:click="zoom">{{ artist.formatted_name }}</div>
          <div>
            <small-button v-on:click="zoom">{{ $nippets.portfolio.view }}</small-button>
          </div>
        </div>
        <div class="likebox-holder"><like-box :imageId="imageId" /></div>
        <permalink-button :image="image" :artist="artist" />
    </div>
  </div>
</template>


<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import LikeBox from '@/components/buttons/LikeBox.vue'
import PermalinkButton from '@/components/buttons/PermalinkButton.vue'

export default {
  components: {
    LikeBox,
    PermalinkButton
  },
  mixins: [ ViewablePanel ],
  props: {
    artistData: Object,
    pageSettings: String,
    wide: Boolean,
    big: Boolean,
    home: Boolean
  },
  computed: {
    imageId () {
      return this.artistData.image_id
    },
    alt () {
      if(!this.home) {
        return this.artist.az_anim_alt || this.artist.az_alt
      }
      return 'View ' + this.artist.formatted_name + '\'s illustration portfolio'
    },
    pfurl() {
      if(this.artist) {
        return '/artists/' + this.artist.portfolio_url
      }
      return ''
    }
  },
  data: function () {
    return {
      artist: { galleries: [] },
      rollovers: [],
      loaded: false,
      mwidth: 0,
      currentUrl: '',
      seendone: false,
      picloaded: false,
      image: null
    }
  },
  created () {
    if(this.artistData.artist_id){
      this.loadArtist()
    }
  },
  mounted() {
    this.measure()
    window.addEventListener('resize', this.measure)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measure)
  },
  methods: {
    measure () {
      if(this.$el) {
        const bounding = this.$el.getBoundingClientRect();
        this.mwidth = bounding.width
      }
    },
    zoom: function () {
      this.$emit('click', this.artist)
    },
    loadArtist: async function () {
      if(this.artistData) {
        this.artist = await this.$store.dispatch('fetchArtistById', this.artistData.artist_id)
        this.loaded = true
        this.setInView()
      }
    },
    getImageUrl() {

      if(this.artistData){
        let url = this.artistData.url
        if(this.artistData.wide) {
          if(this.mwidth < 321) {
            return this.$k.getImage320(url)
          }
          else if(this.mwidth < 501) {
            return this.$k.getImage500(url)
          }
          else {
            return this.$k.getZoomImage(url) 
          }
        }
        else {
          if(this.mwidth < 321){
            return this.$k.getImageCrop320(url)
          }
          else if(this.mwidth < 501) {
            return this.$k.getImageCrop500(url)
          }
          else {
            return this.$k.getImageCrop700(url)
          }
        }
      }
    },
    async loadImage() {
      if(this.artistData){
        this.image = this.artistData
      }
      this.currentUrl = this.getImageUrl()
      this.seendone = true
      await this.$k.loadImage(this.currentUrl)
      this.picloaded = true
    }
  
  },
  watch: {
    artistData: function () {
      if(this.artistData.artist_id) {
        this.loadArtist()
      }
    },
    pageSettings () {
      this.setInView()
    },
    seen () {
      this.loadImage()
    }
  }
}
</script>

<style scoped>

img.smain{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  opacity:0;
  transition:all 0.5s ease;
}

img.smain.loaded{
  opacity:1
}
.square-filler{
  position:relative;
}
.shmim{
  overflow:hidden;
}

.square-filler.wide{
  width:100%;
  padding-bottom:66%;
}

.shmim img.smain{
  width:100%;
  height:100%;
  object-fit: cover;
}
.shmim:hover img.smain{
  width:104%;
}

.greybar{
  position:absolute;
  transition:all 0.3s ease;
  bottom:0;
  left:0;
  width:100%;
  box-sizing:border-box;
  transform: translateY(100%);
}

.shmim:hover .greybar{
  transform:none;
}

.cursable{
  cursor: pointer;
}

</style>
